import type { RowAction } from "@nabble/ui";
import type { AdminUser } from "../../../api/adminUsers";
import type { PendingUserAction } from "./usePendingUserAction";

export interface UserActionHandlers {
  manageMemberships: (user: AdminUser) => void;
  editAccess: (user: AdminUser) => void;
  confirm: (action: PendingUserAction) => void;
  anonymize: (user: AdminUser) => void;
}

/** Whether the user can sign in or is about to, so the status action offered is "Disable". */
function canSignIn(user: AdminUser): boolean {
  return user.status === "ACTIVE" || user.status === "INVITED" || user.status === "LOCKED";
}

/** The row actions of a user; none of them applies to oneself. */
export function userActions(u: AdminUser, handlers: UserActionHandlers): RowAction[] {
  return [
    { label: "Organizations", icon: "briefcase", onSelect: () => handlers.manageMemberships(u), disabled: u.self },
    { label: "Admin Center access", icon: "key", onSelect: () => handlers.editAccess(u), disabled: u.self },
    {
      label: "Send password link",
      icon: "mail",
      onSelect: () => handlers.confirm({ kind: "password", user: u }),
      disabled: u.self || u.status !== "ACTIVE",
    },
    { label: "Reset second factor", icon: "shield", onSelect: () => handlers.confirm({ kind: "mfa", user: u }), disabled: u.self || !u.mfaEnrolled },
    canSignIn(u)
      ? { label: "Disable", icon: "ban", onSelect: () => handlers.confirm({ kind: "status", user: u, status: "DISABLED" }), disabled: u.self }
      : { label: "Activate", icon: "power", onSelect: () => handlers.confirm({ kind: "status", user: u, status: "ACTIVE" }), disabled: u.self },
    { label: "Anonymize", icon: "userX", tone: "danger", onSelect: () => handlers.anonymize(u), disabled: u.self },
  ];
}
